module.exports = __webpack_public_path__ + "static/media/marko_sente.0903b56c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/marko_sente.jpg
// module id = 425
// module chunks = 0